export const NOMENCLATORS_FAMILIES = {
    RESERVATION_TYPE: 'reservationType',
    ORIGIN: 'origin',
    CONCIERGE: 'concierge',
}